module.exports = __webpack_public_path__ + "static/media/ww_epbd1.c0a2d153.gif";